import React, { useState, useEffect } from "react";

import Swiper from 'swiper';
import 'swiper/css';
import one from '../../assets/1.svg';
import two from '../../assets/2.svg';
import three from '../../assets/3.svg';
import {useLocation} from "react-router-dom";
import lzString from "lz-string";
import PopupProduct from "./pop-product";
import {toast} from "react-toastify";

export default function PopConfirm({ dataa, selectedQuantity, clickedSize }) {
      const [selectedSize, setSelectedSize] = useState("");

      useEffect(() => {
  // Log the values for debugging
  console.log("clickedSize:", clickedSize);
  console.log("selectedSize (before update):", selectedSize);

  // Update selectedSize when clickedSize prop changes
  setSelectedSize(clickedSize);

  // Log the updated selectedSize
  console.log("selectedSize (after update):", selectedSize);
}, [clickedSize])


    const [name, setName] = useState('')
  const [photo, setPhoto] = useState('')
    const [price, setPrice] = useState('')
     const [idi, setIdi] = useState('')
  const [size, setSize] = useState([])
   const [color, setColor] = useState([])
    const [data, setData] = useState([])
      const [description, setDescription] = useState('')
    const [foc, setIdFoc] = useState('foc')
    const [locc, setlocc] = useState( localStorage.getItem('selected-theme'))
    const [formData, setFormData] = useState({
  names: "",
  phone: "",
  region: "",
});



   const calculateTotalPrice = (itemPrice, selectedQuantity) => {
  if (typeof itemPrice !== 'string' || typeof selectedQuantity !== 'number') {
    // Handle cases where data is not in the expected format
    return '0'; // You can set a default price or handle it differently
  }

  const price = parseFloat(itemPrice.replace(/,/g, ''));
  if (isNaN(price)) {
    // Handle cases where itemPrice is not formatted correctly
    return '0'; // You can set a default price or handle it differently
  }

  return (price * selectedQuantity).toLocaleString();
};





  // Modified restructureData function
  const restructureData = (dataSource1, selectedQuantity, clickedSize) => {
    // Process data from dataSource1
    const restructuredData = {
      id: dataSource1.id, // Add the 'id' field from dataSource1
      product: dataSource1.product, // Add the 'product' field from dataSource1
      total_price: dataSource1.total_price, // Add the 'total_price' field from dataSource1
      appUser: dataSource1.appUser, // Add the 'appUser' field from dataSource1
      selectedSize: clickedSize, // Use the 'clickedSize' passed as a parameter
         Qty: selectedQuantity,
      // Add other fields from dataSource1 as needed
    };

    return restructuredData;
  };



  const [cartItems, setCartItems] = useState([]);
const [individualItems, setIndividualItems] = useState([]);

// Function to add cart items
const addCartItem = (cartItem) => {
  setCartItems([...cartItems, cartItem]);
};

// Function to add individual items
const addIndividualItem = (individualItem) => {
  setIndividualItems([...individualItems, individualItem]);
};



  useEffect(() => {


         window.history.pushState(null, null, window.location.href);
window.onpopstate = function () {
  // Show an alert when the user clicks the back button
  /*alert("Your click browser back button");*/
  PopConfirm.hide()


  // You can also redirect the user to a specific page if needed
  // window.location.href = "/your-custom-page";
};

    const mainPop = document.getElementById('pop-confirm');
    const show = (data, selectedQuantity, clickedSize, isCartItem = false) => {
       let restructuredData = [];

  if (isCartItem) {
    // Process cart data
    restructuredData = data.map((cartItem) => {
      const { product, Qty } = cartItem;
      return {
        id: product.id,
        product: product,
        total_price: cartItem.total_price,
        appUser: cartItem.appUser,
        selectedSize: cartItem.selectedSize,
      };
    });
  } else {
    // Process individual item data
    restructuredData = [
      {
        id: data.id,
        product: data,
        total_price: calculateTotalPrice(data.price, selectedQuantity),
        appUser: localStorage.getItem('uuid'), // Modify this to get the appUser as needed
        selectedSize: clickedSize,
          Qty: selectedQuantity,
      },
    ];
  }

  setData(restructuredData);

      console.log(restructuredData);

      setlocc(localStorage.getItem('selected-theme'))
        /*setData(d)
        setPhoto(d.photo)
        setName(d.name)
         setIdi(d.id)
        setPrice(d.price)
      setColor(d.colors)
        const sizesArray = d.size.split(",");
    setSize(sizesArray); // Set the array of sizes
console.log(d.colors); // Log the array of sizes
      setDescription(d.description)
            setIdFoc('foc')*/


      /*  window.scrollTo({ top: 0, behavior: 'smooth' });*/

         mainPop.style.display = 'inherit';

                     mainPop.scrollTop = 0;

    }

    const hide = () => {
      mainPop.style.display = 'none';
    };

    PopConfirm.show = show;
    PopConfirm.hide = hide;

  }, []);



  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    const swiperInstance = new Swiper(".swiper", {
      speed: 500,
      allowTouchMove: false,
    });
    setSwiper(swiperInstance);
  }, []);

  const gotoSlide = (index, e) => {
    if (swiper) {
      swiper.slideTo(index);
    }


  };

  const restart = () => {
      setPhoneValue('')
      setNamesValue('')
      setRegionValue('')
      setInputValue('')
      gotoSlide(0)
     PopConfirm.hide()
   /* const inputs = document.querySelectorAll("input");
    const buttons = document.querySelectorAll("button[type=button]");

    /!*buttons.forEach((button) => {
      button.disabled = true;
    });*!/

    inputs.forEach((input) => {
      input.value = "";
    });*/


    gotoSlide(0);
  };



 const [namesValue, setNamesValue] = useState("");
const [phoneValue, setPhoneValue] = useState("");
const [regionValue, setRegionValue] = useState("");
  const [enteredValues, setEnteredValues] = useState([]);

 const checkValid = (event) => {
  const { name, value } = event.target;

  switch (name) {
    case "names":
      setNamesValue(value);
      break;
    case "phone":
      setPhoneValue(value);
      break;
    case "region":
      setRegionValue(value);
      break;
    default:
      break;
  }
};





   const [compressedData, setCompressedData] = useState("");
  const [humanReadableData, setHumanReadableData] = useState("");
  const [decompressedData, setDecompressedData] = useState({});

  const [inputValue, setInputValue] = useState('');


  const compressData = () => {
    const deta = JSON.stringify({data});
    const compressedData = lzString.compressToBase64(deta);
    setCompressedData(compressedData);


 const finalValues = {
  names: namesValue,
  phone: phoneValue,
  region: regionValue,
};

// Convert finalValues object to a string
const finalValuesString = Object.keys(finalValues)
  .map((key) => `${key}: ${finalValues[key]}`)
  .join('%0A'); // Use %0A for a line break

console.log("Final Values:", finalValues);

/*const compressedData = 'Your compressed data goes here'; // Replace with your compressed data*/

const phoneNumber = '+255769465102'; // Replace with the desired phone number

// Add an end-of-line character (%0A) between compressedData and finalValuesString
const message = `${compressedData}%0A%0A${finalValuesString}`;


const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
window.open(whatsappURL, '_blank');

setInputValue(message);




    console.log(compressedData)



    // Further encode the compressed data in hexadecimal for readability
    const encoder = new TextEncoder();
    const dataUint8Array = encoder.encode(compressedData);
    let hexEncodedData = "";
    for (const byte of dataUint8Array) {
      hexEncodedData += byte.toString(16).padStart(2, "0");
    }
    setHumanReadableData(hexEncodedData);
  };



     const decompressData = () => {
    // Decode the hexadecimal-encoded data back to Base64
    const dataUint8Array = new Uint8Array(humanReadableData.length / 2);
    for (let i = 0; i < humanReadableData.length; i += 2) {
      dataUint8Array[i / 2] = parseInt(humanReadableData.substr(i, 2), 16);
    }
    const decoder = new TextDecoder();
    const base64EncodedData = decoder.decode(dataUint8Array);

    const data = lzString.decompressFromBase64(base64EncodedData);
    setDecompressedData(JSON.parse(data));
    console.log(JSON.parse(data))

  };

    /*  window.history.pushState(null, null, window.location.href);
window.onpopstate = function () {
  // Show an alert when the user clicks the back button
 /!* alert("Your click browser back button");*!/
  PopupProduct.hide()

  // You can also redirect the user to a specific page if needed
  // window.location.href = "/your-custom-page";
};
*/




 const copyText = () => {
    const inputField = document.createElement("input");
    inputField.value = inputValue;
    document.body.appendChild(inputField);
    inputField.select();
    document.execCommand("copy");
    document.body.removeChild(inputField);
   /* alert("Copied: " + inputValue);*/
    toast.success('Umefanikiwa kukopi Maokoto ishuing namba tutumie kwa WhatsApp au SMS na tutajibu kwa haraka sana', {
      autoClose: 7000, // Close the toast after 7 seconds
    });
  };



  return (
   <div id={'pop-confirm'}
        className=" no-select background-color" style={{position:"fixed", top:0, bottom:0,left:0, right:0, zIndex:90, display:"none", overflow:"auto",  backgroundColor: locc ==='light'?'hsl(0, 0%, 99%)':'#1D2521'}}>

      <div className="card flex items-center justify-center w-full h-full">
          <span className={'lg:mt-24 lg:mr-16 mr-8 mt-12'} style={{ fontSize:'24px', fontWeight:"bold", textAlign:"right", color:"red", zIndex:97, position:"absolute", top:20, left:0, right:0}}>
          <button onClick={()=>restart()} className={'cursor-pointer bx-burst no-select'}>X</button>
      </span>
        <div className="swiper">
          <div className="swiper-wrapper">
            <div id="login" className="swiper-slide pb-40 mt-14">
              <center><img src={one} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2>Kamilisha Oda yako kwa kujaza taarifa za Upokejia</h2></center>
              <center><h2 className="font-bold pb-5">Jaza majina ya mpokeaje</h2></center>
              <center>
                <input
                     autoComplete={false}
                     name='names'
                  spellCheck="false"
                  type="text"
                  placeholder="mfano: Mwaisa Maokoto"
                  className="block mx-auto mb-4 px-4 py-2 border rounded text-gray-800 border-black"
                  onChange={checkValid}
                     value={namesValue}

                />
              </center>
              <center>
                <button
                  onClick={() => {gotoSlide(1); }}
                  type="button"
                  className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Next
                </button>
              </center>

            </div>
            <div className="swiper-slide mt-16">
              <center><img src={two} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2 className="font-bold text-gray-500 pb-5">Jaza Namba ya simu ya mpokeaji</h2></center>
              <center>
                <input
                     autoComplete={false}
                  spellCheck="false"
                     name={'phone'}
                  type="text"
                  placeholder="mfano: 0769465102"
                  className="block mx-auto mb-4 px-4 py-2 border rounded text-gray-800 border-black"
                  onChange={checkValid}
                      value={phoneValue}
                />
              </center>
              <center>
                  <button
                       onClick={() => {gotoSlide(2);}}
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Next
                  </button>
              </center>
            </div>
            <div className="swiper-slide mt-14" >
              <center><img src={one} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2 className={'font-bold text-gray-600'}>Mkoa/Kituo cha mpokeji</h2></center>
              <center>
                  <p className="font-bold pb-5 text-gray-500">mikoani tunatuma kwa mabasi</p>
              </center>
              <center>
                  <input
                     autoComplete={false}
                  spellCheck="false"
                     name={'region'}
                  type="text"
                   placeholder="mfano: Mbeya-stendikuu"
                  className="block mx-auto mb-4 px-4 py-2 border rounded text-gray-800 border-black"
                  onChange={checkValid}
                      value={regionValue}
                />
              </center>
              <center>
                  <button
                       onClick={() => {gotoSlide(3);}}
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                    Next
                  </button>
              </center>
            </div>
            <div className="swiper-slide" >

                 <center><img src={three} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2 className={'font-bold text-gray-600'}>Ndugu mteja</h2></center>
              <center>
                  <p className="font-bold pb-5">Taarifa zote za usafirishaji na bidhaa<br/> zimekamilika
                      <span className={'text-blue-500'}> bonye za batani hapo chini</span><br/> kututumia Maokoto ishuing number<br/>Pia
                      upate kujua fair delivery price<br/> hakikisha namba hii unapotuma<br/> <span className={'text-blue-500'}>isibadilishwe</span>
                  </p>
              </center>
              <center>

              </center>
              <center>

                 <div style={{display:"flex", flexDirection:"row"}}>
{/*
                    <button
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Tuma
                  </button>


                       <button
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Tuma
                  </button>
*/}



 <button
     type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
     onClick={(e)=>{compressData();}}>Tuma</button>


       {/* <button className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600" onClick={decompressData}>
            Decompress Data
        </button>*/}






                {/*<button
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Tuma kwa sms
                  </button>*/}
                 </div>


                  <center><p className={'font-bold mt-8  text-gray-600'}>Ndugu mteja</p></center>
                  <center>
                      <p className="font-bold pb-5">
                          Kama unapata changamoto wakati wa<br/> utumaji tutumie namba hii kupitia whatsapp au sms kwa
                        namba <a href="tel:+255769465102" ><span className={'font-bold text-blue-500 underline'}>0769465102</span></a> na tutashughulikia kwa haraka sana,
                          bonyeza batani ya juu halafu neno copy
                      </p>
                  </center>

                  <center>

                  <div>
      <input type="text" value={inputValue} readOnly />
      <button className={'text-blue-900 text-xl'} onClick={copyText}>Copy</button>
    </div>
                  </center>

              </center>
            </div>
            <div id="kkk" className="swiper-slide">
              <div className="image-wrapper">
                <img src="jose/3.svg" alt="Finish" />
              </div>
              <h2>Finish</h2>
              <p>j</p>
              <h3>You're all good to go</h3>
              <center>
                <button
                  type="submit"
                  className="block mx-auto px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                >
                  Complete
                </button>
              </center>
              <center>
                <button className="secondary">
                  <a href="#login">Restart</a>
                </button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
